// extracted by mini-css-extract-plugin
export default {"wrapper":"Notifications_wrapper__Z-1+G","placeholder":"Notifications_placeholder__SpmMG"};